import React, {Component} from 'react';

import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import scrollDepth from 'analytics-scroll-depth';

import PrincipalSlider from '../components/principal-slider';
import TitleText from '../components/title-text';
import ProductSlider from '../components/product-slider';
import ProductList from '../components/product-list';
import Bicentury_GA from '../utils/analytics';


class EventArray {
	constructor(window) {
		this.stack = [];
		this.window = window;
	}

	push(obj) {
		// this.stack.push(obj);
		if(obj.eventAction == 'Element Depth'){
			let label = obj.eventLabel.split('.');

			label = label[label.length - 1]
				.split('-')
				.map(function(item, index){
					return item.substring(0,1).toUpperCase() + item.substring(1);
				})
				.join('_');


				Bicentury_GA.sendEvent('Home', 'scroll', label, true);
		}

	}
}

class IndexPage extends Component {
	constructor(props) {
		super(props);
		this.state = {lang: this.props.pathContext.lang};
		const {data} = this.props;

		if ("undefined" != typeof(data)) {
			this.principalSlider = data.allBicenturyHome.edges[0].node.childrens[0].carrousel;
			this.productSlider = data.allBicenturyHome.edges[0].node.childrens[1].carrousel;
			this.title = data.allBicenturyHome.edges[0].node.childrens[1].title;
			this.description = data.allBicenturyHome.edges[0].node.childrens[1].description;

			this.infoGustazos = data.allBicenturyGustazos.edges[0].node;
			this.productListData = data.allBicenturyRecipe.edges;
			this.dataTranslated = data.allBicenturyTranslations.edges;
			this.div3 = data.allBicenturyHome.edges[0].node.childrens[2];
			this.categories = data.allBicenturyGustazosCategory.edges;
			this.translations = data.allBicenturyTranslations.edges[0].node;
		}
		this.dataLayer = [];
	}

	componentDidMount() {
		this.dataLayer = new EventArray(window);
		const elements = [].slice.call(document.querySelectorAll('[data-is-ga-scroll-anchor]'));

		scrollDepth({
			percentages: [],
			elements: elements,
			dataLayer: this.dataLayer
		});
	}

	render() {
		const homeBody = () => {
			if ("undefined" != typeof(this.props.data)) {
				return (
					<div className='homePage'>
						<Helmet title={`Bicentury`} />
						<div className='principal-slider-ga'>
							<PrincipalSlider data={this.principalSlider}/>
						</div>
						<TitleText data={{title: this.title, description: this.description}}/>
						<div className='product-slider-ga' data-is-ga-scroll-anchor='true'>
							<ProductSlider data={this.productSlider} legal={this.translations.image_legal} />
						</div>
						<div className='recipe-list-ga' data-is-ga-scroll-anchor='true'>
							<ProductList
								info={this.infoGustazos}
								data={this.productListData}
								dataTranslated={this.dataTranslated}
								section={this.div3}
								categories={this.categories}
							/>
						</div>
					</div>
				)
			}
		}
		return (
			<div>
			{homeBody()}
			</div>
		);
	}
}

export default IndexPage;

export const query = graphql`
query BicenturyHome($lang: String!) {
		allBicenturyHome(filter: {lang: {eq: $lang}}) {
				edges {
						node {
								id
								lang
								path
								childrens {
										title
										description
										link
										langPath
										carrousel {
												title
												text
												linktext
												title_image
												link
												linktype
												image
												animation
												linkToVideo
												mobile_image
										}
										linktext
										text
										footer
										data {
												title
												text
										}
								}
						}
				}
		}
		allBicenturyGustazos(filter: {lang: {eq: $lang}}) {
				edges {
						node {
								id
								title
								lang
						}
				}
		}
		allBicenturyRecipe(filter: {lang: {eq: $lang}}) {
				edges {
						node {
								id
								title
								image
								avatar
								lang
								langPath
								gustazoId
								legal
						}
				}
		}
		allBicenturyTranslations(filter: {lang: {eq: $lang}}) {
				edges {
						node {
							id
							gustazos
							image_legal
							btnAccept
							cookielayer_title
							cookielayer_text
							cookielayer_acceptall
							cookielayer_reject
							cookielayer_configure
						}
				}
		}
		 allBicenturyGustazosCategory(filter: {lang: {eq: $lang}}) {
				edges {
						node {
								id
								title
								lang
								userDefinedId
								childrens {
										title
										gustazoId
										legal
								}
						}
				}
		}
}
`;



// WEBPACK FOOTER //
// ./src/pages/index.js